module.exports = __webpack_public_path__ + "img/8_diamond.9cc2ef27.jpg";